import React, { Component } from 'react';
import { connectionGet, connectionPut, connectionPost } from '../../utils/connection';
import { Spinner } from 'reactstrap';
import DatePicker from "react-datepicker";
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import "react-datepicker/dist/react-datepicker.css";
import { inject, observer } from 'mobx-react';
import moment from 'moment';


class NoteItem extends Component {
  render(){
    const {note, updateNote} = this.props;
    return (
      <li className="timeline-block">
        <div className="timeline-point">
          <span className="badge badge-ring badge-secondary"></span>
        </div>
        <div className="timeline-content">
          <time>{note.date} {note.user ? (<small>by {note.user.full_name}</small>) : null}</time>
          <p className="mb-0">{note.message}</p>
          {note.follow_up && note.follow_up === 1 ? (
            <div className="custom-control custom-checkbox mr-3">
              <input type="checkbox" id={"follow_up_" + note.id} className="custom-control-input" name="follow_up" onChange={(e)=>updateNote(e,note)} checked={note.follow_up_complete && note.follow_up_complete === 1 ? true : false}/>
              <label className="custom-control-label" htmlFor={"follow_up_" + note.id}>Followed Up? {note.follow_up_complete === 1 && note.follow_up_date ? (<small>completed: {note.follow_up_date}</small>) : null}</label>
            </div>
          ) : null}
        </div>
      </li>
    )
  }
}


@inject('userStore')
class BookingNotes extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading:true,
      booking:null,
      booking_note:{id:null, message:'', follow_up:0},
      note_list:[]
    }
  }

  componentDidMount(){
    this.setState({
      booking:this.props.inquiry
    },()=>{
      this.fetchNotes();
    });
  }

  fetchNotes = () => {
    this.setState({
      loading:true
    },()=>{
      connectionGet('booking-notes/' + this.state.booking.hash_id , {}, {username: this.props.userStore.token}
      ).then((res) => {
        if (res.data.errors === 0){
          this.setState({
            note_list:res.data.item_list,
            loading:false
          })
        } else {
          alert(res.data.message);
          this.setState({
            loading:false
          })
        }
      }).catch((error) => {
        console.log(error);
        return error;
      });
    })
  }

  handleInputChange = (e) => {
    let updated_obj = Object.assign({}, this.state.booking_note);
    let value = e.target.value;
    if (e.target.type === 'checkbox'){
      if (e.target.checked){
        value = 1;
      } else {
        value = 0;
      }
    }
    updated_obj[e.target.name] = value;
    this.setState({booking_note:updated_obj});
  }

  updateNote = (e, note) => {
    // update
    let value = 0;
    if (e.target.type === 'checkbox'){
      if (e.target.checked){
        value = 1;
      } else {
        value = 0;
      }
    }
    note.follow_up_complete = value;
    connectionPut('booking-notes/' + this.state.booking.hash_id + '/' + note.hash_id , {note: note}, {username: this.props.userStore.token}
    ).then((res) => {
      alert(res.data.message);
      if (res.data.errors === 0){
        this.setState({
          note_list:res.data.item_list
        })
      }
    }).catch((error) => {
      console.log(error);
      return error;
    });
  }


  saveNote = () => {
    if (this.state.booking_note.message !== ''){
      if (this.state.booking_note.id){
        // edit
      } else {
        // add
        connectionPost('booking-notes/' + this.state.booking.hash_id , {note: this.state.booking_note}, {username: this.props.userStore.token}
        ).then((res) => {
          alert(res.data.message);
          if (res.data.errors === 0){
            this.setState({
              note_list:res.data.item_list,
              note:{id:null, message:'', follow_up:0}
            })
          }
        }).catch((error) => {
          console.log(error);
          return error;
        });
      }
    } else {
      alert('You must enter a note');
    }
  }

  render(){
    const {booking_note, note_list, loading} = this.state;
    return (
      <div className="card mb-0">
        <div className="card-body">
        {loading ? (
          <div className="p-20"><Spinner color="primary"/>  Loading Notes...</div>
        ) : (
          note_list.length > 0 ? (
          <div className="h-300px b-1">
            <PerfectScrollbar>
              <ol className="timeline timeline-activity timeline-point-sm timeline-content-right w-100 py-20 pr-20">
              {note_list.length > 0 ? (
                note_list.map((note, note_index)=>
                <NoteItem note={note} key={note_index} updateNote={this.updateNote}/>
                )
              ) : null}
              </ol>
            </PerfectScrollbar>
          </div>)
          :
          <div className="alert alert-info">No Notes</div>
        )}
          <div className="form-type-combine mt-20">
            <div className="form-groups-attached">
              <div className="form-group">
                <label>Note</label>
                <textarea className="form-control" name="message" value={booking_note && booking_note.message ? booking_note.message : ''} onChange={this.handleInputChange}></textarea>
              </div>
              <div className="form-group pt-2">
                <div className="custom-control custom-checkbox mr-3">
                  <input type="checkbox" id="follow_up" className="custom-control-input" name="follow_up" onChange={this.handleInputChange} checked={booking_note && booking_note.follow_up && booking_note.follow_up === 1 ? true : false}/>
                  <label className="custom-control-label" htmlFor="follow_up">Requires Follow Up</label>
                </div>
              </div>
            </div>
            <div className="pull-right">
              <button className="btn btn-primary" type="button" onClick={this.saveNote}>Save</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BookingNotes;



// WEBPACK FOOTER //
// ./src/components/business/BookingNotes.js